





















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import TablePager from '@/components/TablePager.vue';
import TableField from '@/types/TableField';
import TableSortEventArgs from '@/types/TableSortEventArgs';
import PagerOptions, { InitPagerOptions } from '@/types/PagerOptions';
import SortOptions from '@/types/SortOptions';
import EntityReference from '@/types/EntityReference';
import { BTable, BButton, BIconArrowUp, BIconArrowDown, BAvatar, BCard, BCardHeader, BCardBody, BCollapse, VBToggle, BCol, BRow, BSpinner } from 'bootstrap-vue';
import UserFilterOptions from '@/types/UserFilterOptions';
import Configuration from '@/types/Configuration';
import InlineSvg from 'vue-inline-svg';
import ColumnHeader from '@/components/ColumnHeader.vue';
import AvatarUtils from '@/types/AvatarUtils';
import AxiosService from '@/services/axiosService';
import i18n from '../i18n';

Vue.directive('b-toggle', VBToggle);

@Component({
    components: {
        'table-pager': TablePager,
        'b-table': BTable,
        'b-btn': BButton,
        'b-icon-arrow-up': BIconArrowUp,
        'b-icon-arrow-down': BIconArrowDown,
        'inline-svg': InlineSvg,
        'b-avatar': BAvatar,
        'column-header': ColumnHeader,
        'b-card': BCard,
        'b-card-header': BCardHeader,
        'b-card-body': BCardBody,
        'b-collapse': BCollapse,
        'b-row': BRow,
        'b-col': BCol,
        'b-spinner': BSpinner
    }
})
export default class UserList extends Vue {
    @Prop() refresh!: boolean
    @Prop() filter!: UserFilterOptions

    users: UserListItem[] = [];
    listOptions: UserListOptions = {
        filter: this.filter,
        pagerOptions: {
            page: 1,
            pageSize: Configuration.DefaultPageSize,
            pageCount: 1,
            rowCount: 0,
            rowStart: 0,
            rowEnd: 0
        },
        sortOptions: {
            sortBy: 'name',
            sortDirection: Configuration.SortDirectionAscending
        }
    };
    isBusy = false;
    apiAccessToken = this.$store.state.apiAccessToken;

    fields: TableField[] = [];

    colors = [
        '#007bff', //blue
        '#6610f2', //indigo
        '#6f42c1', //purple
        '#e83e8c', //pink
        '#dc3545', //red
        '#fd7e14', //orange
        '#ffc107', //yellow
        '#28a745', //green
        '#20c997', //teal
        '#17a2b8', //cyan
        '#80808F', //gray
        '#1B283F', //gray-dark
        '#3699FF', //primary
        '#E5EAEE', //secondary
        '#1BC5BD', //success
        '#8950FC', //info
        '#FFA800', //warning
        '#F64E60', //danger
        '#212121', //dark
        '#464E5F' //dark-75
    ];

    @Watch('refresh')
    refreshList(newVal: boolean) {
        if (newVal) {
            this.loadUsers();
        }
    }

    @Watch('filter')
    filterList(newVal: UserFilterOptions) {
        this.listOptions.filter = newVal;
        this.listOptions.pagerOptions.page = 1;
    }

    mounted() {
        this.isBusy = false;
        this.initFields();
        this.apiAccessToken = this.$store.state.apiAccessToken;
        this.loadUsers();
        this.$root.$on('LocaleChanged', this.onLocaleChanged);
    }

    unmounted() {
        this.$root.$off('LocaleChanged');
    }

    initFields() {
        this.fields = [
            {
                key: 'sequenceId',
                label: this.$t('fields.id').toString(),
                headerTitle: 'Id',
                sortable: true,
                thStyle: 'width: 75px',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: 'text-nowrap datatable-cell text-dark-75 font-size-lg py-4',
                formatter: null
            },
            {
                key: 'name',
                label: this.$t('fields.fullName').toString(),
                headerTitle: 'Name',
                sortable: true,
                thStyle: '',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: 'text-nowrap datatable-cell text-dark-75 font-size-lg py-2',
                formatter: null
            },
            {
                key: 'projects',
                label: this.$t('fields.projects').toString(),
                headerTitle: 'Projects',
                sortable: false,
                thStyle: '',
                thClass: 'unselectable text-nowrap columnheader',
                tdClass: 'text-wrap text-dark-75 font-size-lg py-2',
                formatter: null
            },
            {
                key: 'isActive',
                label: this.$t('fields.status').toString(),
                headerTitle: 'Status',
                sortable: true,
                thStyle: 'width: 100px',
                thClass: 'unselectable text-nowrap  columnheader',
                tdClass: (value: boolean) => { return 'pt-5 py-4 text-nowrap' + (value ? ' text-success' : ' text-danger'); },
                formatter: (value: boolean) => { return value ? 'status.active' : 'status.inactive'; }
            },
            {
                key: 'actions',
                label: '',
                headerTitle: '',
                sortable: false,
                thStyle: 'width: 110px',
                thClass: 'columnheader',
                tdClass: 'pl-3 pr-1 py-4 text-right text-nowrap',
                formatter: null
            }
        ];
    }

    async loadUsers() {
        //this.isBusy = true;
        try {
            const response = await AxiosService.request<ServerData>({
                url: `usersadministration/list`,
                method: 'POST',
                data: this.listOptions
            });

            this.users = response.data.records ?? [];
            this.listOptions.pagerOptions = InitPagerOptions(response.data.totalRecordCount, response.data.pageCount, this.listOptions.pagerOptions.page, this.listOptions.pagerOptions.pageSize);
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusy = false;
            this.$emit('load-complete');
        }
    }

    editUser(id: string) {
        this.$emit('user-selected', id);
    }

    async deleteUser(id: string) {
        try {
            const response = await AxiosService.request({
                url: `usersadministration/candelete/${id}`,
                method: 'GET'
            });

            const canDelete = response.data.canDelete;

            const user = this.users.find(x => x.id == id);

            if (!canDelete) {
                this.$bvModal.msgBoxOk(
                    this.$t('modal.deniedUserDeleteMessage', { userName: user?.name }) as string, {
                        title: this.$t('modal.deniedUserDeleteTitle') as string,
                        centered: true,
                        buttonSize: 'sm',
                        okTitle: this.$t('modal.closeModal') as string
                    }
                );
                return;
            }

            this.$bvModal.msgBoxConfirm(this.$t('modal.confirmUserDeleteMessage', { userName: user?.name }) as string, {
                    title: this.$t('modal.confirmUserDeleteTitle') as string,
                    centered: true,
                    buttonSize: 'sm',
                    okTitle: this.$t('modal.confirmOkTitle') as string,
                    cancelTitle: this.$t('modal.confirmCancelTitle') as string
                })
                .then(value => {
                    if (value) {
                        this.isBusy = true;

                        try {
                            AxiosService.request<boolean>({
                                url: `usersadministration?id=${id}`,
                                method: 'DELETE'
                            });

                            this.$root.$bvToast.toast(this.$t('toaster.userDeleted', { userName: user?.name }) as string, {
                                title: this.$t('toaster.deleteUserTitle') as string,
                                autoHideDelay: Configuration.ToasterAutoHideDelay,
                                appendToast: true,
                                variant: Configuration.ToasterVariantSuccess,
                                toaster: Configuration.ToasterPosition
                            });
                            this.$emit('user-deleted', true);
                        }
                        catch (error) {
                            if (error.response) {
                                switch (error.response.status) {
                                    case 404:
                                        return this.$router.push(`/${i18n.locale}/notfound`);
                                    case 403:
                                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                                    default:
                                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                                }
                            }
                        }
                        finally {
                            this.isBusy = false;
                        }
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusy = false;
        }
    }

    getUserInitials(name: string) {
        return AvatarUtils.getUserInitials(name);
    }

    getColorFromName(name: string) {
        return AvatarUtils.getColorFromText(name);
    }

    onChangePage(page: number) {
        this.listOptions.pagerOptions.page = page;
        this.loadUsers();
    }

    onChangePageSize(pageSize: number) {
        this.listOptions.pagerOptions.pageSize = pageSize;
        this.listOptions.pagerOptions.page = 1;
        this.loadUsers();
    }

    onSortChanged(e: TableSortEventArgs) {
        this.listOptions.sortOptions.sortBy = e.sortBy;
        this.listOptions.sortOptions.sortDirection = e.sortDesc ? -1 : 1;
        this.loadUsers();
    }

    onLocaleChanged(locale: string) { // eslint-disable-line @typescript-eslint/no-unused-vars
        this.$nextTick(() => {
            this.initFields();
        });
    }
}

interface ServerData {
    records: UserListItem[];
    totalRecordCount: number;
    pageCount: number;
}

interface UserListItem {
    id: string;
    sequenceId: number;
    name: string;
    email: string;
    projects: EntityReference[];
    isActive: boolean;
    actions: string;
}

interface UserListOptions {
    filter: UserFilterOptions;
    pagerOptions: PagerOptions;
    sortOptions: SortOptions;
}
